var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderReplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74242 2.77693V0.0322266L4.62121 3.69183L8.74242 7.35143V4.60673C12.1527 4.60673 14.9242 7.06781 14.9242 10.0961C14.9242 11.0202 14.6667 11.8985 14.203 12.6578L15.7073 13.9936C16.5109 12.8683 16.9848 11.5325 16.9848 10.0961C16.9848 6.05227 13.2964 2.77693 8.74242 2.77693ZM8.74242 15.5855C5.33212 15.5855 2.56061 13.1244 2.56061 10.0961C2.56061 9.17208 2.81818 8.29377 3.28182 7.53441L1.77758 6.19865C0.973939 7.32398 0.5 8.65973 0.5 10.0961C0.5 14.14 4.18848 17.4153 8.74242 17.4153V20.16L12.8636 16.5004L8.74242 12.8408V15.5855Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReplace);
export default __webpack_public_path__ + "static/media/order-replace.f8640eedd4a87c8471bf375b8c6aa7d0.svg";
export { ForwardRef as ReactComponent };